export var VelavuUserStatus;
(function (VelavuUserStatus) {
    VelavuUserStatus["ForcePasswordChange"] = "FORCE_CHANGE_PASSWORD";
    VelavuUserStatus["Confirmed"] = "CONFIRMED";
})(VelavuUserStatus || (VelavuUserStatus = {}));
//# sourceMappingURL=user.js.map